
<template>
  <transition name="router-anim">
    <div class="kits">
      <table class="styled-table">
        <thead>
          <tr>
            <th class="title-data">Questions</th>
            <th class="title-data">Yes</th>
            <th class="title-data">No</th>
            <th class="title-data">Skipped</th>
            <th class="title-data">Action</th>
          </tr>
        </thead>
          <tbody>
            <tr v-for="(item,index) in displayedQuestions" :key="index">
              <td>{{item.question}}</td>
              <td
                :class="{
                  'count-clickable': isResearch2,
                  'active-count-cell': isFilterActive(item.type, 'Yes')
                }"
                @click="handleCountClick(item.type, 'Yes')"
                :title="isResearch2 ? 'Click to toggle filter by Yes' : ''"
              >
                <div class="cell-flex">
                  <span class="count-value">{{item.checked}}</span>
                  <img
                    @click.stop="change('yes',item.type,item.checked,item.total)"
                    class="onhold-btn-img"
                    src="../../../images/dashboard/eye.svg"
                    title="View Records"
                    alt="#"
                  />
                </div>
              </td>
              <td
                :class="{
                  'count-clickable': isResearch2,
                  'active-count-cell': isFilterActive(item.type, 'No')
                }"
                @click="handleCountClick(item.type, 'No')"
                :title="isResearch2 ? 'Click to toggle filter by No' : ''"
              >
                <div class="cell-flex">
                  <span class="count-value">{{item.unchecked}}</span>
                  <img
                    @click.stop="change('no',item.type,item.unchecked,item.total)"
                    class="onhold-btn-img"
                    src="../../../images/dashboard/eye.svg"
                    title="View Records"
                    alt="#"
                  />
                </div>
              </td>
              <td
                :class="{
                  'count-clickable': isResearch2,
                  'active-count-cell': isFilterActive(item.type, 'Skipped')
                }"
                @click="handleCountClick(item.type, 'Skipped')"
                :title="isResearch2 ? 'Click to toggle filter by Skipped' : ''"
              >
                <div class="cell-flex">
                  <span class="count-value">{{item.null}}</span>
                  <img
                    @click.stop="change('skipped',item.type,item.null,item.total)"
                    class="onhold-btn-img"
                    title="View Records"
                    src="../../../images/dashboard/eye.svg"
                    alt="#"
                  />
                </div>
            </td>
            <td>
                  <span
                    class="download-link"
                    target="_blank"
                    title="Download"
                  >
                    <span class="download" @click="AnalyticsInfoCsv({type:item.type,data_type:true})">
                      <img src="../../../images/dashboard/download.svg" alt="#" />
                    </span>
                  </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </transition>
</template>
<script>
import { mapActions,mapGetters} from "vuex";
export default {
  name: "AnalyticsCount",
  props: {
    isResearch2: {
      type: Boolean,
      default: false
    },
    activeFilters: {
      type: Object,
      default: () => ({ musty_damp_odor: "Any", visible_mold: "Any", symptoms: "Any" })
    },
    surveyCounts: {
      type: Object,
      default: null
    },
    selectedRiskFilter: {
      type: String,
      default: null
    },
    filteredKits: {
      type: Array,
      default: () => []
    }
  },
  data() {
      return {
        analyticsUserCount: [],
        analyticsUsers: [],
        date_from: null,
        date_to: null,
      };
  },
  computed: {
    ...mapGetters(["getAnalyticsCounts","getAnalyticsAll"]),
    displayedQuestions() {
      if (this.isResearch2 && this.surveyCounts) {
        const questionsList = [
          { question: "Is there visible mold?", type: "visible_mold" },
          { question: 'Is there a "musty" or "damp" odor?', type: "musty_damp_odor" },
          { question: "Is anyone experiencing symptoms that you think might be mold-related?", type: "symptoms" }
        ];
        return questionsList.map(q => {
          const counts = this.surveyCounts[q.type] || { checked: 0, unchecked: 0, null: 0, total: 0 };
          return {
            question: q.question,
            type: q.type,
            checked: counts.checked !== undefined ? counts.checked : 0,
            unchecked: counts.unchecked !== undefined ? counts.unchecked : 0,
            null: counts.null !== undefined ? counts.null : 0,
            total: counts.total || 0
          };
        });
      }
      return this.analyticsUserCount || [];
    }
  },
  watch: {
    getAnalyticsCounts(obj) {
      this.analyticsUserCount = obj.data;
    },
    getAnalyticsAll(obj) {
      this.analyticsUsers = obj.data;
    }
  },
  mounted() {
    this.analyticsUserCount = this.$store.getters.getAnalyticsCounts.data;
    if(this.$store.getters.getAnalyticsAll) {
      this.analyticsUsers = this.$store.getters.getAnalyticsAll;
    }
  },
  methods:{
    ...mapActions([
      "getAnalyticsInfoList",
      "setAnalyticsHead",
      "setAdminPginationPage",
      "setAnalyticsFilter",
      "setSerachString",
      "setStatusFilter",
      "setDateFromAnalytics",
      "setDateToAnalytics",
      "getAnalyticsInfoCsv"
    ]),
    isFilterActive(type, response) {
      if (!this.isResearch2 || !this.activeFilters) return false;
      return this.activeFilters[type] === response;
    },
    handleCountClick(type, response) {
      if (!this.isResearch2) return;
      this.$emit("select-survey-filter", { type, response });
    },
    change(item,type,count,total){
      if (this.isResearch2) {
        const responseMap = { yes: "Yes", no: "No", skipped: "Skipped" };
        const response = responseMap[item] || "Any";
        this.$emit("select-survey-filter", { type, response });
        this.$emit("shows", { show: true });
        return;
      }
      this.setSerachString("");
      this.setStatusFilter([]);
      this.setDateFromAnalytics(null);
      this.setDateToAnalytics(null);
      this.setAnalyticsHead({status:3,type,show:true,item,count,total});
      const data ={item,type};
      this.setAdminPginationPage(item).then(() => {
        this.setAnalyticsFilter(data);
        this.setAdminPginationPage(null).then(() => {
          this.getAnalyticsInfoList(data).then(res => {
            this.$emit("shows", { show: true});
          });
        });
      });
    },
    exportResearch2Csv(type) {
      const kits = this.filteredKits || [];
      const rows = [];
      rows.push([
        "Kit ID",
        "Musty Damp Odor",
        "Visible Mold",
        "Symptoms",
        "Laboratory Risk Level",
        "State",
        "City"
      ]);

      const formatResponse = (val) => {
        if (val === true || val === 1 || val === "1" || val === "yes" || val === "Yes") return "Yes";
        if (val === false || val === 0 || val === "0" || val === "no" || val === "No") return "No";
        return "Skipped";
      };

      kits.forEach(kit => {
        const kitId = kit.kit_id || kit.id || "N/A";
        const musty = formatResponse(kit.musty_damp_odor);
        const mold = formatResponse(kit.visible_mold);
        const symp = formatResponse(kit.symptoms);
        const riskLabel = kit.riskLabel || (kit.riskInfo ? kit.riskInfo.label : "Not Evident");
        const state = kit.state || kit.rstate || "";
        const city = kit.city || kit.rcity || "";

        rows.push([kitId, musty, mold, symp, riskLabel, state, city]);
      });

      const csvContent = rows.map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Research2_Map_Kits_${type}_${new Date().toISOString().slice(0, 10)}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    AnalyticsInfoCsv(data) {
      if (this.isResearch2) {
        this.exportResearch2Csv(data.type);
        return;
      }
      this.getAnalyticsInfoCsv(data).then(async response => {
        if (response && response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${data.type}_Count.csv`
          );
          link.click();
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.kits {
  margin: 20px 0 0 0;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  background-color: $white;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
img{
  height: 1em;
}
:hover .onhold-btn-img {
  cursor: pointer;
}
.cell-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.count-clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}
.count-clickable:hover {
  background-color: #e6f2ff !important;
}
.active-count-cell {
  background-color: #005eb8 !important;
  color: #ffffff !important;
  font-weight: bold;
}
.active-count-cell .count-value {
  color: #ffffff !important;
}
.download-link {
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  margin: 0 20px 0 0;
  cursor: pointer;
}
.download-link-btn {
  text-align: left;
  background-color: transparent;
  border: none;
  outline: none;
}
.download-link.span {
  max-width: 135px;
}
.download {
  width: 25px;
  height: 25px;
  background-color: #03409a;
  border-radius: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.download img {
  max-width: 12px;
  height: auto;
  cursor: pointer;
}
.action-icons {
  display: flex;
  align-items: center; // Vertically align items
  gap: 5px; // Add spacing between eye icon and download button
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
  font-size: 14px;
  font-family: TTNormsLight,sans-serif;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.title-data {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.sort-data{
  padding-left: 10px;
}
.sort-data .down {
  transform: rotate(180deg);
}
.styled-table tbody tr .changed-name{
  width:150px !important;
}
.entity-label {
  font-weight: bold; /* Highlight the entity label */
  margin-right: 8px; /* Add space after "Indoor sample" */
  width: 20px;
}
</style>

